import $ from 'jquery';

$(function () {

  const requestButton = $('.btn-request');
  const requestMenu = $('.request-menu');

  $(requestButton).on('click', function() {
    requestMenu.toggleClass('request-menu--active');
  });

});